import { useTranslation } from 'react-i18next';

import { StatusDot } from '@/components/ui/custom/StatusDot';
import { cn } from '@/lib/utils';

import { WebSession } from './api';

interface WebSessionStatusProps {
  session: Pick<WebSession, 'is_current' | 'is_active'>;
}

const WebSessionStatus = ({ session }: WebSessionStatusProps) => {
  const { t } = useTranslation();
  const isActive = session.is_current || session.is_active;

  return (
    <div className="flex items-center gap-1">
      <StatusDot aria-hidden="true" variant={isActive ? 'successful' : 'neutral'} />
      <span
        className={cn(
          'text-xs leading-4 font-normal',
          isActive ? 'text-success' : 'text-muted-foreground'
        )}
      >
        {isActive ? t('web_sessions.active_now') : t('web_sessions.inactive')}
      </span>
    </div>
  );
};

export default WebSessionStatus;
